import type { ProblemDetails } from './api'
import { PERMISSION_KEYS } from './permissions.generated'
import type { PermissionKey } from './permissions.generated'

export { PERMISSION_KEYS }
export type { PermissionKey }

export const HIERARCHY_PERMISSIONS = {
  read: PERMISSION_KEYS.hierarchyRead,
  edit: PERMISSION_KEYS.hierarchyEdit,
  delete: PERMISSION_KEYS.hierarchyDelete,
} as const

export const SETTING_PERMISSIONS = {
  edit: PERMISSION_KEYS.settingEdit,
} as const

export const BILLING_PERMISSIONS = {
  write: PERMISSION_KEYS.billingWrite,
  accountManage: PERMISSION_KEYS.billingAccountManage,
  usageRead: PERMISSION_KEYS.billingUsageRead,
} as const

export const CAPABILITY_PERMISSIONS = {
  read: PERMISSION_KEYS.capabilityRead,
  edit: PERMISSION_KEYS.capabilityEdit,
} as const

export const CLASSIFICATION_CATALOG_PERMISSIONS = {
  read: PERMISSION_KEYS.classificationCatalogRead,
} as const

// Gates every identity-and-access surface: users, invitations, roles, groups,
// impersonation, and the hierarchy access tab.
export const IAM_PERMISSIONS = {
  manage: PERMISSION_KEYS.iamManage,
  manageServiceAccountRateLimit: PERMISSION_KEYS.serviceaccountRatelimitManage,
} as const

export const SERVICE_ACCOUNT_PERMISSIONS = {
  read: PERMISSION_KEYS.iamServiceaccountRead,
  manage: PERMISSION_KEYS.iamServiceaccountManage,
} as const

export const OAUTH_APPLICATION_PERMISSIONS = {
  read: PERMISSION_KEYS.oauthApplicationRead,
  manage: PERMISSION_KEYS.oauthApplicationManage,
} as const

export const SSO_PERMISSIONS = {
  manage: PERMISSION_KEYS.ssoManage,
} as const

export const AUDIT_PERMISSIONS = {
  read: PERMISSION_KEYS.auditRead,
} as const

export const ASSET_PERMISSIONS = {
  evidenceRead: PERMISSION_KEYS.assetEvidenceRead,
} as const

export const AGENT_PERMISSIONS = {
  read: PERMISSION_KEYS.agentRead,
  diagnosticRead: PERMISSION_KEYS.agentDiagnosticRead,
  diagnosticManage: PERMISSION_KEYS.agentDiagnosticManage,
  installer: PERMISSION_KEYS.agentInstallerRead,
  manage: PERMISSION_KEYS.agentManage,
  pskManage: PERMISSION_KEYS.agentPskManage,
  printerPolicyManage: PERMISSION_KEYS.printerPolicyManage,
} as const

export const EAUTOMATE_PERMISSIONS = {
  read: PERMISSION_KEYS.eautomateRead,
  manage: PERMISSION_KEYS.eautomateManage,
} as const

export const WORKFLOW_PERMISSIONS = {
  read: PERMISSION_KEYS.workflowRead,
  manage: PERMISSION_KEYS.workflowManage,
} as const

export const INTEGRATION_PERMISSIONS = {
  read: PERMISSION_KEYS.integrationRead,
  manage: PERMISSION_KEYS.integrationManage,
} as const

export const CONTENT_PERMISSIONS = {
  read: PERMISSION_KEYS.contentRead,
  manage: PERMISSION_KEYS.contentManage,
  publish: PERMISSION_KEYS.contentPublish,
} as const

export const LEARNING_PERMISSIONS = {
  read: PERMISSION_KEYS.learningRead,
  manage: PERMISSION_KEYS.learningManage,
} as const

export function can(
  permissions: string[] | undefined,
  key: PermissionKey,
): boolean {
  return permissions?.includes(key) ?? false
}

export const PERMISSION_DENIED_MESSAGE =
  'You don’t have permission to perform this action.'

export function formatPermissionError(problem: ProblemDetails | null): string {
  return problem?.detail ?? PERMISSION_DENIED_MESSAGE
}
